<template>
  <svg
    width="32"
    height="70%"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.20801 24.6169C6.20801 19.6551 6.20801 9.26138 6.20801 7.3811C6.20801 5.50083 7.7749 5.03076 8.55835 5.03076C13.7813 5.03076 24.384 5.03076 25.0107 5.03076C25.6375 5.03076 25.7942 5.55306 25.7942 5.81421V20.6997V21.9329C25.7942 22.1172 25.6448 22.2666 25.4605 22.2666V22.2666M6.20801 24.6169C6.20801 25.4004 6.67808 26.9673 8.55835 26.9673C10.3592 26.9673 19.9698 26.9673 25.1376 26.9673C25.502 26.9673 25.7942 26.6719 25.7942 26.3075V26.3075C25.7942 26.2258 25.7791 26.145 25.7494 26.0689C25.3963 25.1643 24.8961 23.8637 25.4605 22.2666M6.20801 24.6169C6.20801 23.8335 6.67808 22.2666 8.55835 22.2666C10.4386 22.2666 20.6099 22.2666 25.4605 22.2666" stroke="#5C53A2" stroke-width="2.19365"/>
    <path d="M6.20801 23.05V6.59766L7.7749 5.03076H25.7942V21.4832L25.0107 22.2666H8.55835L6.20801 23.05Z" fill="#5C53A2"/>
    <rect
      x="21.0918"
      y="8.16739"
      width="1.88027"
      height="12.5352"
      rx="0.783447"
      transform="rotate(90 21.0918 8.16739)"
      fill="#F1F0FF"
    />
    <rect
      x="16.3926"
      y="12.8672"
      width="1.88027"
      height="7.83447"
      rx="0.783447"
      transform="rotate(90 16.3926 12.8672)"
      fill="#F1F0FF"
    />
  </svg>
</template>
